import { z } from 'zod';

//--------------------------------
// Address Schema
//--------------------------------
const addressSchema = z
    .object({
    addressLineOne: z.string(),
    addressLineTwo: z.string(),
    city: z.string(),
    state: z.string(),
    zip: z.string(),
    zipBase: z.string().optional(),
    zipExtension: z.string().optional(),
    county: z.string().optional(),
    lat: z.number().optional(),
    lng: z.number().optional(),
    country: z.string().optional(),
    addressString: z.string().optional(),
})
    .refine((value) => {
    return (typeof value.addressLineOne === 'string' && value.addressLineOne.trim().length > 0);
}, { message: 'Enter a valid address line one' })
    .refine((value) => {
    return typeof value.city === 'string' && value.city.trim().length > 0;
}, { message: 'Enter a valid city' })
    .refine((value) => {
    return typeof value.state === 'string' && value.state.trim().length > 0;
}, { message: 'Enter a valid state' })
    .refine((value) => {
    return typeof value.zip === 'string' && value.zip.trim().length > 0;
}, { message: 'Enter a valid zip code' });

export { addressSchema };
//# sourceMappingURL=Address.js.map
